import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common_layout" }
const _hoisted_2 = { style: {"padding-left":"32px","padding-right":"32px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "舊密碼", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "新密碼", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"margin-top":"25px"}
}, "再次輸入新密碼", -1)
const _hoisted_6 = { class: "center_flex_layout" }

import {reactive, onMounted, getCurrentInstance} from 'vue';
    import { get, post } from '../utils/request';
    import { useRouter } from "vue-router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'changePassword',
  setup(__props) {


    const router = useRouter();
    const {proxy}: any = getCurrentInstance();

    const oldPass = reactive({value: ''});
    const newPass = reactive({value: ''});
    const confirmNewPass = reactive({value: ''});

    const changePassword =()=> {

        if (!oldPass.value) {
            proxy.$toast('請輸入舊密碼');
            return;
        }

        if (!newPass.value) {
            proxy.$toast('請輸入新密碼');
            return;
        }

        if (!confirmNewPass.value) {
            proxy.$toast('請再次輸入新密碼');
            return;
        }

        if (newPass.value !== confirmNewPass.value) {
            proxy.$toast('兩次密碼不一致');
            return;
        }

        let isCorrect = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;  // 正则判断密码至少8位，且是数字，字母两种组合

        if (!isCorrect.test(newPass.value)) {
            proxy.$toast('登入密碼要求至少8位字符，最大20位字符，並且需要字母數字兩種組合');
            return;
        }

        let changePassParams = {
            password: oldPass.value,
            confirmPassword: confirmNewPass.value,
        };

        post('/modify/password', changePassParams, null)
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    proxy.$toast('修改成功');
                    localStorage.clear();
                    router.push({path:'/login'});
                }
            })
            .catch(error => {
                console.log(error);
            })

    }


return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader, { title: "修改密碼" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: oldPass.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldPass.value) = $event)),
        placeholder: "请输入旧密码"
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: newPass.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPass.value) = $event)),
        placeholder: "请输入新密码"
      }, null, 8, ["modelValue"]),
      _hoisted_5,
      _createVNode(_component_el_input, {
        class: "common_font",
        style: {"margin-top":"5px"},
        size: "large",
        modelValue: confirmNewPass.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmNewPass.value) = $event)),
        placeholder: "请再次输入新密码"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"134px","margin-top":"140px"},
          size: "large",
          onClick: changePassword
        }, {
          default: _withCtx(() => [
            _createTextVNode("修改密碼")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})